import { WheelColumn } from '@focuslee/shared-mini-app';
import { Box } from '@mui/material';
import { Text } from '@telegram-apps/telegram-ui';
import type { CSSProperties, FC } from 'react';

export type TimeWheelPickerProps = {
  hours: number;
  minutes: number;
  seconds: number;
  onChange: (time: { hours: number; minutes: number; seconds: number }) => void;
  accent?: string;
};

const pad = (i: number) => String(i).padStart(2, '0');

const separatorStyle: CSSProperties = {
  fontSize: 40,
  fontWeight: 800,
  color: 'var(--tg-theme-hint-color)',
  lineHeight: 1,
  paddingLeft: 2,
  paddingRight: 2,
  gridRow: 1,
};

const labelStyle: CSSProperties = {
  fontSize: 13,
  color: 'var(--tg-theme-hint-color)',
  textAlign: 'center',
  gridRow: 2,
  marginTop: 4,
};

export const TimeWheelPicker: FC<TimeWheelPickerProps> = ({
  hours,
  minutes,
  seconds,
  onChange,
  accent = 'var(--tg-theme-button-color)',
}) => {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: '1fr auto 1fr auto 1fr',
        alignItems: 'center',
        width: '100%',
        maxWidth: 340,
        mx: 'auto',
      }}
    >
      <Box sx={{ gridColumn: 1, gridRow: 1 }}>
        <WheelColumn
          count={24}
          selectedIndex={hours}
          labelAt={pad}
          onCommittedIndex={i => onChange({ hours: i, minutes, seconds })}
          selectionOutline={accent}
          size="lg"
        />
      </Box>
      <Text style={{ ...separatorStyle, gridColumn: 2 }}>:</Text>
      <Box sx={{ gridColumn: 3, gridRow: 1 }}>
        <WheelColumn
          count={60}
          selectedIndex={minutes}
          labelAt={pad}
          onCommittedIndex={i => onChange({ hours, minutes: i, seconds })}
          selectionOutline={accent}
          size="lg"
        />
      </Box>
      <Text style={{ ...separatorStyle, gridColumn: 4 }}>:</Text>
      <Box sx={{ gridColumn: 5, gridRow: 1 }}>
        <WheelColumn
          count={60}
          selectedIndex={seconds}
          labelAt={pad}
          onCommittedIndex={i => onChange({ hours, minutes, seconds: i })}
          selectionOutline={accent}
          size="lg"
        />
      </Box>

      <Text style={{ ...labelStyle, gridColumn: 1 }}>hours</Text>
      <Text style={{ ...labelStyle, gridColumn: 3 }}>min</Text>
      <Text style={{ ...labelStyle, gridColumn: 5 }}>sec</Text>
    </Box>
  );
};
